var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/capitalizeEachWord/capitalizeEachWord.ts
var capitalizeEachWord = /* @__PURE__ */ __name((str) => {
  if (!str) {
    return "";
  }
  return str.split(" ").filter(Boolean).map((w) => (w[0] ?? "").toUpperCase() + w.substring(1)).join(" ");
}, "capitalizeEachWord");

// src/cookies/cookies.ts
function setSessionCookie(name, value) {
  document.cookie = `${name}=${value}; path=/`;
}
__name(setSessionCookie, "setSessionCookie");
function setCookie(name, value, options = {}) {
  const { days, hours, minutes, seconds, path = "/", domain, secure = false, httpOnly = false, sameSite = "lax" } = options;
  let cookieString = `${name}=${value}; path=${path}`;
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  if (days || hours || minutes || seconds) {
    const now = /* @__PURE__ */ new Date();
    const expirationTime = new Date(now.getTime() + (days || 0) * 24 * 60 * 60 * 1e3 + (hours || 0) * 60 * 60 * 1e3 + (minutes || 0) * 60 * 1e3 + (seconds || 0) * 1e3);
    cookieString += `; expires=${expirationTime.toUTCString()}`;
  }
  if (secure) {
    cookieString += "; secure";
  }
  if (httpOnly) {
    cookieString += "; httpOnly";
  }
  cookieString += `; sameSite=${sameSite}`;
  document.cookie = cookieString;
}
__name(setCookie, "setCookie");
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let cookie of ca) {
    cookie = cookie.trim();
    if (cookie.startsWith(nameEQ)) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
}
__name(getCookie, "getCookie");
function deleteCookie(name, path = "/", domain) {
  let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  document.cookie = cookieString;
}
__name(deleteCookie, "deleteCookie");

// src/formatDurationToHoursAndMinutes/formatDurationToHoursAndMinutes.ts
var formatDurationToHoursAndMinutes = /* @__PURE__ */ __name((minutes) => {
  if (minutes === 0) return "0min";
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours === 0) {
    return `${remainingMinutes}min`;
  }
  if (remainingMinutes === 0) {
    return `${hours}h`;
  }
  return `${hours}h ${remainingMinutes}min`;
}, "formatDurationToHoursAndMinutes");

// ../../node_modules/@mobily/ts-belt/dist/pipe.mjs
function pipe() {
  let e = arguments[0];
  for (let t2 = 1, p = arguments.length; t2 < p; t2++) {
    e = arguments[t2](e);
  }
  return e;
}
__name(pipe, "pipe");

// ../../node_modules/@mobily/ts-belt/dist/caml-aa4fccd9.mjs
function int_compare(e, r) {
  if (e < r) {
    return -1;
  } else if (e === r) {
    return 0;
  } else {
    return 1;
  }
}
__name(int_compare, "int_compare");
function bool_compare(e, r) {
  if (e) {
    if (r) {
      return 0;
    } else {
      return 1;
    }
  } else if (r) {
    return -1;
  } else {
    return 0;
  }
}
__name(bool_compare, "bool_compare");
function string_compare(e, r) {
  if (e === r) {
    return 0;
  } else if (e < r) {
    return -1;
  } else {
    return 1;
  }
}
__name(string_compare, "string_compare");
function int_max(e, r) {
  if (e > r) {
    return e;
  } else {
    return r;
  }
}
__name(int_max, "int_max");

// ../../node_modules/@mobily/ts-belt/dist/caml_obj-c29533cc.mjs
var for_in = /* @__PURE__ */ __name(function(r, e) {
  for (var n2 in r) {
    e(n2);
  }
}, "for_in");
function compare(t2, a) {
  if (t2 === a) {
    return 0;
  }
  var i3 = typeof t2;
  var u = typeof a;
  switch (i3) {
    case "boolean":
      if ("boolean" === u) {
        return bool_compare(t2, a);
      }
      break;
    case "function":
      if ("function" === u) {
        throw {
          RE_EXN_ID: "Invalid_argument",
          _1: "compare: functional value",
          Error: new Error()
        };
      }
      break;
    case "number":
      if ("number" === u) {
        return int_compare(t2, a);
      }
      break;
    case "string":
      if ("string" === u) {
        return string_compare(t2, a);
      } else {
        return 1;
      }
    case "undefined":
      return -1;
  }
  switch (u) {
    case "string":
      return -1;
    case "undefined":
      return 1;
    default:
      if ("boolean" === i3) {
        return 1;
      }
      if ("boolean" === u) {
        return -1;
      }
      if ("function" === i3) {
        return 1;
      }
      if ("function" === u) {
        return -1;
      }
      if ("number" === i3) {
        if (null === a || void 0 !== a.BS_PRIVATE_NESTED_SOME_NONE) {
          return 1;
        } else {
          return -1;
        }
      }
      if ("number" === u) {
        if (null === t2 || void 0 !== t2.BS_PRIVATE_NESTED_SOME_NONE) {
          return -1;
        } else {
          return 1;
        }
      }
      if (null === t2) {
        if (void 0 !== a.BS_PRIVATE_NESTED_SOME_NONE) {
          return 1;
        } else {
          return -1;
        }
      }
      if (null === a) {
        if (void 0 !== t2.BS_PRIVATE_NESTED_SOME_NONE) {
          return -1;
        } else {
          return 1;
        }
      }
      if (void 0 !== t2.BS_PRIVATE_NESTED_SOME_NONE) {
        if (void 0 !== a.BS_PRIVATE_NESTED_SOME_NONE) {
          return aux_obj_compare(t2, a);
        } else {
          return -1;
        }
      }
      var o = 0 | t2.TAG;
      var f = 0 | a.TAG;
      if (248 === o) {
        return int_compare(t2[1], a[1]);
      }
      if (251 === o) {
        throw {
          RE_EXN_ID: "Invalid_argument",
          _1: "equal: abstract value",
          Error: new Error()
        };
      }
      if (o !== f) {
        if (o < f) {
          return -1;
        } else {
          return 1;
        }
      }
      var l = 0 | t2.length;
      var s = 0 | a.length;
      if (l === s) {
        if (Array.isArray(t2)) {
          var c = 0;
          while (1) {
            var v2 = c;
            if (v2 === l) {
              return 0;
            }
            var E = compare(t2[v2], a[v2]);
            if (0 !== E) {
              return E;
            }
            c = v2 + 1 | 0;
          }
        } else if (t2 instanceof Date && a instanceof Date) {
          return t2 - a;
        } else {
          return aux_obj_compare(t2, a);
        }
      } else if (l < s) {
        var _2 = 0;
        while (1) {
          var d = _2;
          if (d === l) {
            return -1;
          }
          var p = compare(t2[d], a[d]);
          if (0 !== p) {
            return p;
          }
          _2 = d + 1 | 0;
        }
      } else {
        var m = 0;
        while (1) {
          var b2 = m;
          if (b2 === s) {
            return 1;
          }
          var N3 = compare(t2[b2], a[b2]);
          if (0 !== N3) {
            return N3;
          }
          m = b2 + 1 | 0;
        }
      }
  }
}
__name(compare, "compare");
function aux_obj_compare(e, n2) {
  var t2 = {
    contents: void 0
  };
  var a = {
    contents: void 0
  };
  var do_key = /* @__PURE__ */ __name(function(r, e2) {
    var n3 = r[2];
    var t3 = r[1];
    if (Object.prototype.hasOwnProperty.call(t3, e2) && !(compare(r[0][e2], t3[e2]) > 0)) {
      return;
    }
    var a2 = n3.contents;
    if (void 0 !== a2 && e2 >= a2) {
      return;
    } else {
      n3.contents = e2;
      return;
    }
  }, "do_key");
  var i3 = [e, n2, a];
  var u = [n2, e, t2];
  for_in(e, (function(r) {
    return do_key(i3, r);
  }));
  for_in(n2, (function(r) {
    return do_key(u, r);
  }));
  var o = t2.contents;
  var f = a.contents;
  if (void 0 !== o) {
    if (void 0 !== f) {
      return string_compare(o, f);
    } else {
      return -1;
    }
  } else if (void 0 !== f) {
    return 1;
  } else {
    return 0;
  }
}
__name(aux_obj_compare, "aux_obj_compare");
function equal(r, e) {
  if (r === e) {
    return true;
  }
  var n2 = typeof r;
  if ("string" === n2 || "number" === n2 || "boolean" === n2 || "undefined" === n2 || null === r) {
    return false;
  }
  var t2 = typeof e;
  if ("function" === n2 || "function" === t2) {
    throw {
      RE_EXN_ID: "Invalid_argument",
      _1: "equal: functional value",
      Error: new Error()
    };
  }
  if ("number" === t2 || "undefined" === t2 || null === e) {
    return false;
  }
  var a = 0 | r.TAG;
  var i3 = 0 | e.TAG;
  if (248 === a) {
    return r[1] === e[1];
  }
  if (251 === a) {
    throw {
      RE_EXN_ID: "Invalid_argument",
      _1: "equal: abstract value",
      Error: new Error()
    };
  }
  if (a !== i3) {
    return false;
  }
  var u = 0 | r.length;
  if (u === (0 | e.length)) {
    if (Array.isArray(r)) {
      var o = 0;
      while (1) {
        var f = o;
        if (f === u) {
          return true;
        }
        if (!equal(r[f], e[f])) {
          return false;
        }
        o = f + 1 | 0;
      }
    } else if (r instanceof Date && e instanceof Date) {
      return !(r > e || r < e);
    } else {
      var l = {
        contents: true
      };
      for_in(r, (function(r2) {
        if (!Object.prototype.hasOwnProperty.call(e, r2)) {
          l.contents = false;
          return;
        }
      }));
      if (l.contents) {
        for_in(e, (function(n3) {
          if (!Object.prototype.hasOwnProperty.call(r, n3) || !equal(e[n3], r[n3])) {
            l.contents = false;
            return;
          }
        }));
      }
      return l.contents;
    }
  } else {
    return false;
  }
}
__name(equal, "equal");
function lessthan(r, e) {
  return compare(r, e) < 0;
}
__name(lessthan, "lessthan");

// ../../node_modules/@mobily/ts-belt/dist/caml_option-16487d6d.mjs
function some(_2) {
  if (void 0 === _2) {
    return {
      BS_PRIVATE_NESTED_SOME_NONE: 0
    };
  } else if (null !== _2 && void 0 !== _2.BS_PRIVATE_NESTED_SOME_NONE) {
    return {
      BS_PRIVATE_NESTED_SOME_NONE: _2.BS_PRIVATE_NESTED_SOME_NONE + 1 | 0
    };
  } else {
    return _2;
  }
}
__name(some, "some");
function nullable_to_opt(_2) {
  if (null == _2) {
    return;
  } else {
    return some(_2);
  }
}
__name(nullable_to_opt, "nullable_to_opt");
function undefined_to_opt(_2) {
  if (void 0 === _2) {
    return;
  } else {
    return some(_2);
  }
}
__name(undefined_to_opt, "undefined_to_opt");
function null_to_opt(_2) {
  if (null === _2) {
    return;
  } else {
    return some(_2);
  }
}
__name(null_to_opt, "null_to_opt");
function valFromOption(_2) {
  if (null === _2 || void 0 === _2.BS_PRIVATE_NESTED_SOME_NONE) {
    return _2;
  }
  var n2 = _2.BS_PRIVATE_NESTED_SOME_NONE;
  if (0 === n2) {
    return;
  } else {
    return {
      BS_PRIVATE_NESTED_SOME_NONE: n2 - 1 | 0
    };
  }
}
__name(valFromOption, "valFromOption");

// ../../node_modules/@mobily/ts-belt/dist/belt_Array-b9ebcaa6.mjs
function floor_int(r) {
  if (r > 2147483647) {
    return 2147483647;
  } else if (r < -2147483648) {
    return -2147483648;
  } else {
    return Math.floor(r);
  }
}
__name(floor_int, "floor_int");
function random_int(r, n2) {
  return floor_int(Math.random() * (n2 - r | 0)) + r | 0;
}
__name(random_int, "random_int");
function get(r, a) {
  if (a >= 0 && a < r.length) {
    return some(r[a]);
  }
}
__name(get, "get");
function getExn(r, n2) {
  if (!(n2 >= 0 && n2 < r.length)) {
    throw {
      RE_EXN_ID: "Assert_failure",
      _1: ["belt_Array.ml", 35, 2],
      Error: new Error()
    };
  }
  return r[n2];
}
__name(getExn, "getExn");
function swapUnsafe(r, n2, a) {
  var e = r[n2];
  r[n2] = r[a];
  r[a] = e;
}
__name(swapUnsafe, "swapUnsafe");
function shuffle(r) {
  var n2 = r.slice(0);
  !(/* @__PURE__ */ __name(function shuffleInPlace(r2) {
    var n3 = r2.length;
    for (var a = 0; a < n3; ++a) {
      swapUnsafe(r2, a, random_int(a, n3));
    }
  }, "shuffleInPlace"))(n2);
  return n2;
}
__name(shuffle, "shuffle");
function reverse(r) {
  var n2 = r.length;
  var a = new Array(n2);
  for (var e = 0; e < n2; ++e) {
    a[e] = r[(n2 - 1 | 0) - e | 0];
  }
  return a;
}
__name(reverse, "reverse");
function make(r, n2) {
  if (r <= 0) {
    return [];
  }
  var a = new Array(r);
  for (var e = 0; e < r; ++e) {
    a[e] = n2;
  }
  return a;
}
__name(make, "make");
function makeByU(r, n2) {
  if (r <= 0) {
    return [];
  }
  var a = new Array(r);
  for (var e = 0; e < r; ++e) {
    a[e] = n2(e);
  }
  return a;
}
__name(makeByU, "makeByU");
function range(r, n2) {
  var a = n2 - r | 0;
  if (a < 0) {
    return [];
  }
  var e = new Array(a + 1 | 0);
  for (var t2 = 0; t2 <= a; ++t2) {
    e[t2] = r + t2 | 0;
  }
  return e;
}
__name(range, "range");
function rangeBy(r, n2, a) {
  var e = n2 - r | 0;
  if (e < 0 || a <= 0) {
    return [];
  }
  var t2 = 1 + (e / a | 0) | 0;
  var v2 = new Array(t2);
  var f = r;
  for (var o = 0; o < t2; ++o) {
    v2[o] = f;
    f = f + a | 0;
  }
  return v2;
}
__name(rangeBy, "rangeBy");
function zip(r, n2) {
  var a = r.length;
  var e = n2.length;
  var t2 = a < e ? a : e;
  var v2 = new Array(t2);
  for (var f = 0; f < t2; ++f) {
    v2[f] = [r[f], n2[f]];
  }
  return v2;
}
__name(zip, "zip");
function zipByU(r, n2, a) {
  var e = r.length;
  var t2 = n2.length;
  var v2 = e < t2 ? e : t2;
  var f = new Array(v2);
  for (var o = 0; o < v2; ++o) {
    f[o] = a(r[o], n2[o]);
  }
  return f;
}
__name(zipByU, "zipByU");
function concat(r, n2) {
  var a = r.length;
  var e = n2.length;
  var t2 = new Array(a + e | 0);
  for (var v2 = 0; v2 < a; ++v2) {
    t2[v2] = r[v2];
  }
  for (var f = 0; f < e; ++f) {
    t2[a + f | 0] = n2[f];
  }
  return t2;
}
__name(concat, "concat");
function concatMany(r) {
  var n2 = r.length;
  var a = 0;
  for (var e = 0; e < n2; ++e) {
    a = a + r[e].length | 0;
  }
  var t2 = new Array(a);
  a = 0;
  for (var v2 = 0; v2 < n2; ++v2) {
    var f = r[v2];
    for (var o = 0, i3 = f.length; o < i3; ++o) {
      t2[a] = f[o];
      a = a + 1 | 0;
    }
  }
  return t2;
}
__name(concatMany, "concatMany");
function slice(n2, a, e) {
  if (e <= 0) {
    return [];
  }
  var t2 = n2.length;
  var v2 = a < 0 ? int_max(t2 + a | 0, 0) : a;
  var f = t2 - v2 | 0;
  var o = f < e ? f : e;
  if (o <= 0) {
    return [];
  }
  var i3 = new Array(o);
  for (var u = 0; u < o; ++u) {
    i3[u] = n2[v2 + u | 0];
  }
  return i3;
}
__name(slice, "slice");
function sliceToEnd(n2, a) {
  var e = n2.length;
  var t2 = a < 0 ? int_max(e + a | 0, 0) : a;
  var v2 = e > t2 ? e - t2 | 0 : 0;
  var f = new Array(v2);
  for (var o = 0; o < v2; ++o) {
    f[o] = n2[t2 + o | 0];
  }
  return f;
}
__name(sliceToEnd, "sliceToEnd");
function blitUnsafe(r, n2, a, e, t2) {
  if (e <= n2) {
    for (var v2 = 0; v2 < t2; ++v2) {
      a[v2 + e | 0] = r[v2 + n2 | 0];
    }
    return;
  }
  for (var f = t2 - 1 | 0; f >= 0; --f) {
    a[f + e | 0] = r[f + n2 | 0];
  }
}
__name(blitUnsafe, "blitUnsafe");
function forEachU(r, n2) {
  for (var a = 0, e = r.length; a < e; ++a) {
    n2(r[a]);
  }
}
__name(forEachU, "forEachU");
function mapU(r, n2) {
  var a = r.length;
  var e = new Array(a);
  for (var t2 = 0; t2 < a; ++t2) {
    e[t2] = n2(r[t2]);
  }
  return e;
}
__name(mapU, "mapU");
function getByU(r, a) {
  var e = r.length;
  var t2 = 0;
  var v2;
  while (void 0 === v2 && t2 < e) {
    var f = r[t2];
    if (a(f)) {
      v2 = some(f);
    }
    t2 = t2 + 1 | 0;
  }
  return v2;
}
__name(getByU, "getByU");
function getIndexByU(r, n2) {
  var a = r.length;
  var e = 0;
  var t2;
  while (void 0 === t2 && e < a) {
    if (n2(r[e])) {
      t2 = e;
    }
    e = e + 1 | 0;
  }
  return t2;
}
__name(getIndexByU, "getIndexByU");
function keepMapU(r, n2) {
  var e = r.length;
  var t2 = new Array(e);
  var v2 = 0;
  for (var f = 0; f < e; ++f) {
    var o = n2(r[f]);
    if (void 0 !== o) {
      t2[v2] = valFromOption(o);
      v2 = v2 + 1 | 0;
    }
  }
  t2.length = v2;
  return t2;
}
__name(keepMapU, "keepMapU");
function forEachWithIndexU(r, n2) {
  for (var a = 0, e = r.length; a < e; ++a) {
    n2(a, r[a]);
  }
}
__name(forEachWithIndexU, "forEachWithIndexU");
function mapWithIndexU(r, n2) {
  var a = r.length;
  var e = new Array(a);
  for (var t2 = 0; t2 < a; ++t2) {
    e[t2] = n2(t2, r[t2]);
  }
  return e;
}
__name(mapWithIndexU, "mapWithIndexU");
function reduceU(r, n2, a) {
  var e = n2;
  for (var t2 = 0, v2 = r.length; t2 < v2; ++t2) {
    e = a(e, r[t2]);
  }
  return e;
}
__name(reduceU, "reduceU");
function reduceReverseU(r, n2, a) {
  var e = n2;
  for (var t2 = r.length - 1 | 0; t2 >= 0; --t2) {
    e = a(e, r[t2]);
  }
  return e;
}
__name(reduceReverseU, "reduceReverseU");
function reduceWithIndexU(r, n2, a) {
  var e = n2;
  for (var t2 = 0, v2 = r.length; t2 < v2; ++t2) {
    e = a(e, r[t2], t2);
  }
  return e;
}
__name(reduceWithIndexU, "reduceWithIndexU");
function everyU(r, n2) {
  var a = r.length;
  var e = 0;
  while (1) {
    var t2 = e;
    if (t2 === a) {
      return true;
    }
    if (!n2(r[t2])) {
      return false;
    }
    e = t2 + 1 | 0;
  }
}
__name(everyU, "everyU");
function someU(r, n2) {
  var a = r.length;
  var e = 0;
  while (1) {
    var t2 = e;
    if (t2 === a) {
      return false;
    }
    if (n2(r[t2])) {
      return true;
    }
    e = t2 + 1 | 0;
  }
}
__name(someU, "someU");
function eqU(r, n2, a) {
  var e = r.length;
  if (e === n2.length) {
    return (/* @__PURE__ */ __name(function everyAux2(r2, n3, a2, e2, t2) {
      while (1) {
        var v2 = a2;
        if (v2 === t2) {
          return true;
        }
        if (!e2(r2[v2], n3[v2])) {
          return false;
        }
        a2 = v2 + 1 | 0;
      }
    }, "everyAux2"))(r, n2, 0, a, e);
  } else {
    return false;
  }
}
__name(eqU, "eqU");
function partitionU(r, n2) {
  var a = r.length;
  var e = 0;
  var t2 = 0;
  var v2 = new Array(a);
  var f = new Array(a);
  for (var o = 0; o < a; ++o) {
    var i3 = r[o];
    if (n2(i3)) {
      v2[e] = i3;
      e = e + 1 | 0;
    } else {
      f[t2] = i3;
      t2 = t2 + 1 | 0;
    }
  }
  v2.length = e;
  f.length = t2;
  return [v2, f];
}
__name(partitionU, "partitionU");
function unzip(r) {
  var n2 = r.length;
  var a = new Array(n2);
  var e = new Array(n2);
  for (var t2 = 0; t2 < n2; ++t2) {
    var v2 = r[t2];
    a[t2] = v2[0];
    e[t2] = v2[1];
  }
  return [a, e];
}
__name(unzip, "unzip");

// ../../node_modules/@mobily/ts-belt/dist/caml_exceptions-99f2c2ac.mjs
function sub(n2, r, t2) {
  var e = new Array(t2);
  var u = 0;
  var a = r;
  while (u < t2) {
    e[u] = n2[a];
    u = u + 1 | 0;
    a = a + 1 | 0;
  }
  return e;
}
__name(sub, "sub");
function app(n2, r) {
  while (1) {
    var t2 = r;
    var e = n2;
    var u = e.length;
    var a = 0 === u ? 1 : u;
    var c = a - t2.length | 0;
    if (0 === c) {
      return e.apply(null, t2);
    }
    if (c >= 0) {
      return /* @__PURE__ */ (function(n3, r2) {
        return function(t3) {
          return app(n3, r2.concat([t3]));
        };
      })(e, t2);
    }
    r = sub(t2, a, 0 | -c);
    n2 = e.apply(null, sub(t2, 0, a));
  }
}
__name(app, "app");
function _1(n2, r) {
  var t2 = n2.length;
  if (1 === t2) {
    return n2(r);
  } else {
    switch (t2) {
      case 1:
        return n2(r);
      case 2:
        return function(t3) {
          return n2(r, t3);
        };
      case 3:
        return function(t3, e) {
          return n2(r, t3, e);
        };
      case 4:
        return function(t3, e, u) {
          return n2(r, t3, e, u);
        };
      case 5:
        return function(t3, e, u, a) {
          return n2(r, t3, e, u, a);
        };
      case 6:
        return function(t3, e, u, a, c) {
          return n2(r, t3, e, u, a, c);
        };
      case 7:
        return function(t3, e, u, a, c, i3) {
          return n2(r, t3, e, u, a, c, i3);
        };
      default:
        return app(n2, [r]);
    }
  }
}
__name(_1, "_1");
function __1(n2) {
  if (1 === n2.length) {
    return n2;
  } else {
    return function(r) {
      return _1(n2, r);
    };
  }
}
__name(__1, "__1");
var n = {
  contents: 0
};
function create(r) {
  n.contents = n.contents + 1 | 0;
  return r + "/" + n.contents;
}
__name(create, "create");
function is_extension(n2) {
  if (null == n2) {
    return false;
  } else {
    return "string" == typeof n2.RE_EXN_ID;
  }
}
__name(is_extension, "is_extension");

// ../../node_modules/@mobily/ts-belt/dist/belt_Option-91f3b350.mjs
function getExn2(t2) {
  if (void 0 !== t2) {
    return valFromOption(t2);
  }
  throw {
    RE_EXN_ID: "Not_found",
    Error: new Error()
  };
}
__name(getExn2, "getExn");
function mapWithDefaultU(t2, i3, a) {
  if (void 0 !== t2) {
    return a(valFromOption(t2));
  } else {
    return i3;
  }
}
__name(mapWithDefaultU, "mapWithDefaultU");
function mapU2(t2, a) {
  if (void 0 !== t2) {
    return some(a(valFromOption(t2)));
  }
}
__name(mapU2, "mapU");
function flatMapU(t2, i3) {
  if (void 0 !== t2) {
    return i3(valFromOption(t2));
  }
}
__name(flatMapU, "flatMapU");
function flatMap(n2, i3) {
  return flatMapU(n2, __1(i3));
}
__name(flatMap, "flatMap");
function getWithDefault(t2, i3) {
  if (void 0 !== t2) {
    return valFromOption(t2);
  } else {
    return i3;
  }
}
__name(getWithDefault, "getWithDefault");
function isSome(t2) {
  return void 0 !== t2;
}
__name(isSome, "isSome");
function isNone(t2) {
  return void 0 === t2;
}
__name(isNone, "isNone");

// ../../node_modules/@mobily/ts-belt/dist/Array.bs-4b4ec77c.mjs
function merge(n2, t2, e, u, i3, f, a, o, c) {
  var s = t2 + e | 0;
  var l = i3 + f | 0;
  var h2 = t2;
  var p = n2[t2];
  var v2 = i3;
  var g2 = u[i3];
  var _2 = o;
  while (1) {
    var d = _2;
    var y = g2;
    var m = v2;
    var A = p;
    var x = h2;
    if (c(A, y) <= 0) {
      a[d] = A;
      var B = x + 1 | 0;
      if (B >= s) {
        return blitUnsafe(u, m, a, d + 1 | 0, l - m | 0);
      }
      _2 = d + 1 | 0;
      p = n2[B];
      h2 = B;
      continue;
    }
    a[d] = y;
    var W = m + 1 | 0;
    if (W >= l) {
      return blitUnsafe(n2, x, a, d + 1 | 0, s - x | 0);
    }
    _2 = d + 1 | 0;
    g2 = u[W];
    v2 = W;
  }
}
__name(merge, "merge");
function insertionSort(n2, t2, r, e, u, i3) {
  for (var f = 0; f < u; ++f) {
    var a = n2[t2 + f | 0];
    var o = (e + f | 0) - 1 | 0;
    while (o >= e && i3(r[o], a) > 0) {
      r[o + 1 | 0] = r[o];
      o = o - 1 | 0;
    }
    r[o + 1 | 0] = a;
  }
}
__name(insertionSort, "insertionSort");
function sortTo(n2, t2, r, e, u, i3) {
  if (u <= 5) {
    return insertionSort(n2, t2, r, e, u, i3);
  }
  var f = u / 2 | 0;
  var a = u - f | 0;
  sortTo(n2, t2 + f | 0, r, e + f | 0, a, i3);
  sortTo(n2, t2, n2, t2 + a | 0, f, i3);
  merge(n2, t2 + a | 0, f, r, e + f | 0, a, r, e, i3);
}
__name(sortTo, "sortTo");
function stableSortByU(n2, t2) {
  var r = n2.slice(0);
  !(/* @__PURE__ */ __name(function stableSortInPlaceByU(n3, t3) {
    var r2 = n3.length;
    if (r2 <= 5) {
      return insertionSort(n3, 0, n3, 0, r2, t3);
    }
    var e = r2 / 2 | 0;
    var u = r2 - e | 0;
    var i3 = new Array(u);
    sortTo(n3, e, i3, 0, u, t3);
    sortTo(n3, 0, n3, u, e, t3);
    merge(n3, u, e, i3, 0, u, n3, 0, t3);
  }, "stableSortInPlaceByU"))(r, t2);
  return r;
}
__name(stableSortByU, "stableSortByU");
function get$1(t2, r) {
  if (r in t2) {
    return some(t2[r]);
  }
}
__name(get$1, "get$1");
function placeholder(n2) {
}
__name(placeholder, "placeholder");
function makeEmpty(n2) {
  return [];
}
__name(makeEmpty, "makeEmpty");
var z = makeByU;
function makeWithIndex() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return z(t2, n2[0]);
    }, "fn");
  }
  return z(arguments[0], arguments[1]);
}
__name(makeWithIndex, "makeWithIndex");
var S = make;
function make2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return S(t2, n2[0]);
    }, "fn");
  }
  return S(arguments[0], arguments[1]);
}
__name(make2, "make");
var O = make;
function repeat() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return O(t2, n2[0]);
    }, "fn");
  }
  return O(arguments[0], arguments[1]);
}
__name(repeat, "repeat");
function length(n2) {
  return n2.length;
}
__name(length, "length");
function isEmpty(n2) {
  return 0 === n2.length;
}
__name(isEmpty, "isEmpty");
function isNotEmpty(n2) {
  return 0 !== n2.length;
}
__name(isNotEmpty, "isNotEmpty");
var $ = reverse;
function _append(n2, t2) {
  return concat(n2, [t2]);
}
__name(_append, "_append");
function append() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _append(t2, n2[0]);
    }, "fn");
  }
  return _append(arguments[0], arguments[1]);
}
__name(append, "append");
function _prepend(n2, t2) {
  return concat([t2], n2);
}
__name(_prepend, "_prepend");
function prepend() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _prepend(t2, n2[0]);
    }, "fn");
  }
  return _prepend(arguments[0], arguments[1]);
}
__name(prepend, "prepend");
function _prependToAll(n2, t2) {
  return reduceU(n2, [], (function(n3, r) {
    return concat(n3, [t2, r]);
  }));
}
__name(_prependToAll, "_prependToAll");
function prependToAll() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _prependToAll(t2, n2[0]);
    }, "fn");
  }
  return _prependToAll(arguments[0], arguments[1]);
}
__name(prependToAll, "prependToAll");
function _intersperse(n2, t2) {
  return reduceWithIndexU(n2, [], (function(r, e, u) {
    if ((n2.length - 1 | 0) === u) {
      r.push(e);
    } else {
      r.push(e, t2);
    }
    return r;
  }));
}
__name(_intersperse, "_intersperse");
function intersperse() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _intersperse(t2, n2[0]);
    }, "fn");
  }
  return _intersperse(arguments[0], arguments[1]);
}
__name(intersperse, "intersperse");
var C = get;
function get2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return C(t2, n2[0]);
    }, "fn");
  }
  return C(arguments[0], arguments[1]);
}
__name(get2, "get");
var D = get;
function at() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return D(t2, n2[0]);
    }, "fn");
  }
  return D(arguments[0], arguments[1]);
}
__name(at, "at");
function _getUnsafe(n2, t2) {
  return n2[t2];
}
__name(_getUnsafe, "_getUnsafe");
function getUnsafe() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _getUnsafe(t2, n2[0]);
    }, "fn");
  }
  return _getUnsafe(arguments[0], arguments[1]);
}
__name(getUnsafe, "getUnsafe");
function _getUndefined(n2, t2) {
  return n2[t2];
}
__name(_getUndefined, "_getUndefined");
function getUndefined() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _getUndefined(t2, n2[0]);
    }, "fn");
  }
  return _getUndefined(arguments[0], arguments[1]);
}
__name(getUndefined, "getUndefined");
var N = getByU;
function getBy() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return N(t2, n2[0]);
    }, "fn");
  }
  return N(arguments[0], arguments[1]);
}
__name(getBy, "getBy");
var R = getByU;
function find() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return R(t2, n2[0]);
    }, "fn");
  }
  return R(arguments[0], arguments[1]);
}
__name(find, "find");
function head(n2) {
  return get(n2, 0);
}
__name(head, "head");
function last(n2) {
  var t2 = n2.length;
  if (0 === t2) {
    return;
  } else {
    return get(n2, t2 - 1 | 0);
  }
}
__name(last, "last");
function tail(n2) {
  var t2 = n2.length;
  if (1 === t2) {
    return [];
  }
  if (0 === t2) {
    return;
  }
  var r = sliceToEnd(n2, 1);
  if (0 !== r.length) {
    return r;
  }
}
__name(tail, "tail");
function tailOrEmpty(n2) {
  var t2 = tail(n2);
  if (void 0 !== t2) {
    return t2;
  } else {
    return [];
  }
}
__name(tailOrEmpty, "tailOrEmpty");
function init(n2) {
  var t2 = n2.length;
  if (0 === t2) {
    return;
  } else {
    return slice(n2, 0, t2 - 1 | 0);
  }
}
__name(init, "init");
function initOrEmpty(n2) {
  var t2 = init(n2);
  if (void 0 !== t2) {
    return t2;
  } else {
    return [];
  }
}
__name(initOrEmpty, "initOrEmpty");
function _take(n2, t2) {
  var r = n2.length;
  return slice(n2, 0, t2 < 0 ? 0 : r < t2 ? r : t2);
}
__name(_take, "_take");
function take() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _take(t2, n2[0]);
    }, "fn");
  }
  return _take(arguments[0], arguments[1]);
}
__name(take, "take");
function _takeExactly(n2, t2) {
  if (t2 < 0 || t2 > n2.length) {
    return;
  } else {
    return slice(n2, 0, t2);
  }
}
__name(_takeExactly, "_takeExactly");
function takeExactly() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _takeExactly(t2, n2[0]);
    }, "fn");
  }
  return _takeExactly(arguments[0], arguments[1]);
}
__name(takeExactly, "takeExactly");
function _takeWhile(n2, t2) {
  var r = 0;
  var e = false;
  var u = [];
  while (r < n2.length && !e) {
    var i3 = n2[r];
    if (t2(i3)) {
      u.push(i3);
      r = r + 1 | 0;
    } else {
      e = true;
    }
  }
  return u;
}
__name(_takeWhile, "_takeWhile");
function takeWhile() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _takeWhile(t2, n2[0]);
    }, "fn");
  }
  return _takeWhile(arguments[0], arguments[1]);
}
__name(takeWhile, "takeWhile");
function _drop(n2, t2) {
  var r = n2.length;
  return sliceToEnd(n2, t2 < 0 ? 0 : r < t2 ? r : t2);
}
__name(_drop, "_drop");
function drop() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _drop(t2, n2[0]);
    }, "fn");
  }
  return _drop(arguments[0], arguments[1]);
}
__name(drop, "drop");
function _dropExactly(n2, t2) {
  if (t2 < 0 || t2 > n2.length) {
    return;
  } else {
    return sliceToEnd(n2, t2);
  }
}
__name(_dropExactly, "_dropExactly");
function dropExactly() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _dropExactly(t2, n2[0]);
    }, "fn");
  }
  return _dropExactly(arguments[0], arguments[1]);
}
__name(dropExactly, "dropExactly");
function _dropWhile(n2, t2) {
  return reduceU(n2, [], (function(n3, r) {
    if (!t2(r)) {
      n3.push(r);
    }
    return n3;
  }));
}
__name(_dropWhile, "_dropWhile");
function dropWhile() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _dropWhile(t2, n2[0]);
    }, "fn");
  }
  return _dropWhile(arguments[0], arguments[1]);
}
__name(dropWhile, "dropWhile");
function uncons(n2) {
  if (0 !== n2.length) {
    return [getExn(n2, 0), sliceToEnd(n2, 1)];
  }
}
__name(uncons, "uncons");
function _map(n2, t2) {
  return mapU(n2, t2);
}
__name(_map, "_map");
function map() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _map(t2, n2[0]);
    }, "fn");
  }
  return _map(arguments[0], arguments[1]);
}
__name(map, "map");
var G = mapWithIndexU;
function mapWithIndex() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return G(t2, n2[0]);
    }, "fn");
  }
  return G(arguments[0], arguments[1]);
}
__name(mapWithIndex, "mapWithIndex");
function _filter(n2, t2) {
  var r = 0;
  var e = [];
  while (r < n2.length) {
    var u = n2[r];
    if (t2(u)) {
      e.push(u);
    }
    r = r + 1 | 0;
  }
  return e;
}
__name(_filter, "_filter");
function filter() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _filter(t2, n2[0]);
    }, "fn");
  }
  return _filter(arguments[0], arguments[1]);
}
__name(filter, "filter");
var P = filter;
function _filterWithIndex(n2, t2) {
  var r = 0;
  var e = [];
  while (r < n2.length) {
    var u = n2[r];
    if (t2(r, u)) {
      e.push(u);
    }
    r = r + 1 | 0;
  }
  return e;
}
__name(_filterWithIndex, "_filterWithIndex");
function filterWithIndex() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _filterWithIndex(t2, n2[0]);
    }, "fn");
  }
  return _filterWithIndex(arguments[0], arguments[1]);
}
__name(filterWithIndex, "filterWithIndex");
var H = filterWithIndex;
function _reject(n2, t2) {
  return filter(n2, (function(n3) {
    return !t2(n3);
  }));
}
__name(_reject, "_reject");
function reject() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _reject(t2, n2[0]);
    }, "fn");
  }
  return _reject(arguments[0], arguments[1]);
}
__name(reject, "reject");
function _rejectWithIndex(n2, t2) {
  return filterWithIndex(n2, (function(n3, r) {
    return !t2(n3, r);
  }));
}
__name(_rejectWithIndex, "_rejectWithIndex");
function rejectWithIndex() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _rejectWithIndex(t2, n2[0]);
    }, "fn");
  }
  return _rejectWithIndex(arguments[0], arguments[1]);
}
__name(rejectWithIndex, "rejectWithIndex");
var J = reduceU;
function reduce() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return J(t2, n2[0], n2[1]);
    }, "fn");
  }
  return J(arguments[0], arguments[1], arguments[2]);
}
__name(reduce, "reduce");
var K = reduceReverseU;
function reduceReverse() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return K(t2, n2[0], n2[1]);
    }, "fn");
  }
  return K(arguments[0], arguments[1], arguments[2]);
}
__name(reduceReverse, "reduceReverse");
var L = reduceWithIndexU;
function reduceWithIndex() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return L(t2, n2[0], n2[1]);
    }, "fn");
  }
  return L(arguments[0], arguments[1], arguments[2]);
}
__name(reduceWithIndex, "reduceWithIndex");
function _splitAt(n2, t2) {
  if (t2 < 0 || t2 > n2.length) {
    return;
  } else {
    return [slice(n2, 0, t2), sliceToEnd(n2, t2)];
  }
}
__name(_splitAt, "_splitAt");
function splitAt() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _splitAt(t2, n2[0]);
    }, "fn");
  }
  return _splitAt(arguments[0], arguments[1]);
}
__name(splitAt, "splitAt");
function _splitEvery(n2, t2) {
  if (t2 < 1 || n2.length <= t2) {
    return [n2];
  }
  var r = 0;
  var e = [];
  while (r < n2.length) {
    var u = r + t2 | 0;
    e.push(slice(n2, r, t2));
    r = u;
  }
  return e;
}
__name(_splitEvery, "_splitEvery");
function splitEvery() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _splitEvery(t2, n2[0]);
    }, "fn");
  }
  return _splitEvery(arguments[0], arguments[1]);
}
__name(splitEvery, "splitEvery");
var Q = shuffle;
var V = partitionU;
function partition() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return V(t2, n2[0]);
    }, "fn");
  }
  return V(arguments[0], arguments[1]);
}
__name(partition, "partition");
var X = concat;
function concat2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return X(t2, n2[0]);
    }, "fn");
  }
  return X(arguments[0], arguments[1]);
}
__name(concat2, "concat");
var Y = concatMany;
var Z = everyU;
function every() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return Z(t2, n2[0]);
    }, "fn");
  }
  return Z(arguments[0], arguments[1]);
}
__name(every, "every");
var nn = someU;
function some2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return nn(t2, n2[0]);
    }, "fn");
  }
  return nn(arguments[0], arguments[1]);
}
__name(some2, "some");
var tn = slice;
function slice2() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return tn(t2, n2[0], n2[1]);
    }, "fn");
  }
  return tn(arguments[0], arguments[1], arguments[2]);
}
__name(slice2, "slice");
var rn = sliceToEnd;
function sliceToEnd2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return rn(t2, n2[0]);
    }, "fn");
  }
  return rn(arguments[0], arguments[1]);
}
__name(sliceToEnd2, "sliceToEnd");
var en = eqU;
function eq() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return en(t2, n2[0], n2[1]);
    }, "fn");
  }
  return en(arguments[0], arguments[1], arguments[2]);
}
__name(eq, "eq");
var un = range;
function range2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return un(t2, n2[0]);
    }, "fn");
  }
  return un(arguments[0], arguments[1]);
}
__name(range2, "range");
var an = rangeBy;
function rangeBy2() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return an(t2, n2[0], n2[1]);
    }, "fn");
  }
  return an(arguments[0], arguments[1], arguments[2]);
}
__name(rangeBy2, "rangeBy");
function copy(n2) {
  return n2.slice(0);
}
__name(copy, "copy");
var on = zip;
function zip2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return on(t2, n2[0]);
    }, "fn");
  }
  return on(arguments[0], arguments[1]);
}
__name(zip2, "zip");
var cn = zipByU;
function zipWith() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return cn(t2, n2[0], n2[1]);
    }, "fn");
  }
  return cn(arguments[0], arguments[1], arguments[2]);
}
__name(zipWith, "zipWith");
var sn = unzip;
function _replaceAt(n2, t2, r) {
  return mapWithIndexU(n2, (function(n3, e) {
    if (n3 === t2) {
      return r;
    } else {
      return e;
    }
  }));
}
__name(_replaceAt, "_replaceAt");
function replaceAt() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _replaceAt(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _replaceAt(arguments[0], arguments[1], arguments[2]);
}
__name(replaceAt, "replaceAt");
function _insertAt(n2, t2, r) {
  var e = splitAt(n2, t2);
  if (void 0 !== e) {
    return concat(e[0], concat([r], e[1]));
  } else {
    return n2;
  }
}
__name(_insertAt, "_insertAt");
function insertAt() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _insertAt(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _insertAt(arguments[0], arguments[1], arguments[2]);
}
__name(insertAt, "insertAt");
function _updateAt(n2, t2, r) {
  return mapWithIndexU(n2, (function(n3, e) {
    if (n3 === t2) {
      return r(e);
    } else {
      return e;
    }
  }));
}
__name(_updateAt, "_updateAt");
function updateAt() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _updateAt(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _updateAt(arguments[0], arguments[1], arguments[2]);
}
__name(updateAt, "updateAt");
function _swapAt(n2, r, e) {
  var i3 = get(n2, r);
  var f = get(n2, e);
  if (void 0 === i3) {
    return n2;
  }
  if (void 0 === f) {
    return n2;
  }
  var a = valFromOption(f);
  var o = valFromOption(i3);
  return mapWithIndexU(n2, (function(n3, t2) {
    if (r === n3) {
      return a;
    } else if (e === n3) {
      return o;
    } else {
      return t2;
    }
  }));
}
__name(_swapAt, "_swapAt");
function swapAt() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _swapAt(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _swapAt(arguments[0], arguments[1], arguments[2]);
}
__name(swapAt, "swapAt");
function _removeAt(n2, t2) {
  return filterWithIndex(n2, (function(n3, r) {
    return n3 !== t2;
  }));
}
__name(_removeAt, "_removeAt");
function removeAt() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _removeAt(t2, n2[0]);
    }, "fn");
  }
  return _removeAt(arguments[0], arguments[1]);
}
__name(removeAt, "removeAt");
function _uniqBy(n2, t2) {
  var r = 0;
  var e = [];
  while (r < n2.length) {
    var u = n2[r];
    var i3 = someU(e, /* @__PURE__ */ (function(n3) {
      return function(r2) {
        return equal(t2(r2), t2(n3));
      };
    })(u));
    if (!i3) {
      e.push(u);
    }
    r = r + 1 | 0;
  }
  return e;
}
__name(_uniqBy, "_uniqBy");
function uniqBy() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _uniqBy(t2, n2[0]);
    }, "fn");
  }
  return _uniqBy(arguments[0], arguments[1]);
}
__name(uniqBy, "uniqBy");
function uniq(n2) {
  return uniqBy(n2, (function(n3) {
    return n3;
  }));
}
__name(uniq, "uniq");
var ln = forEachU;
function forEach() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return ln(t2, n2[0]);
    }, "fn");
  }
  return ln(arguments[0], arguments[1]);
}
__name(forEach, "forEach");
var hn = forEachWithIndexU;
function forEachWithIndex() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return hn(t2, n2[0]);
    }, "fn");
  }
  return hn(arguments[0], arguments[1]);
}
__name(forEachWithIndex, "forEachWithIndex");
var pn = getIndexByU;
function getIndexBy() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return pn(t2, n2[0]);
    }, "fn");
  }
  return pn(arguments[0], arguments[1]);
}
__name(getIndexBy, "getIndexBy");
function _includes(n2, t2) {
  return someU(n2, (function(n3) {
    return equal(n3, t2);
  }));
}
__name(_includes, "_includes");
function includes() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _includes(t2, n2[0]);
    }, "fn");
  }
  return _includes(arguments[0], arguments[1]);
}
__name(includes, "includes");
function _join(n2, t2) {
  return n2.join(t2);
}
__name(_join, "_join");
function join() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _join(t2, n2[0]);
    }, "fn");
  }
  return _join(arguments[0], arguments[1]);
}
__name(join, "join");
var vn = stableSortByU;
function sort() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return vn(t2, n2[0]);
    }, "fn");
  }
  return vn(arguments[0], arguments[1]);
}
__name(sort, "sort");
function _sortBy(n2, t2) {
  return stableSortByU(n2, (function(n3, r) {
    var e = t2(n3);
    var u = t2(r);
    if (e === u) {
      return 0;
    } else if (lessthan(e, u)) {
      return -1;
    } else {
      return 1;
    }
  }));
}
__name(_sortBy, "_sortBy");
function sortBy() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _sortBy(t2, n2[0]);
    }, "fn");
  }
  return _sortBy(arguments[0], arguments[1]);
}
__name(sortBy, "sortBy");
function _groupBy(n2, t2) {
  return reduceU(n2, {}, (function(n3, r) {
    var e = t2(r);
    var u = get$1(n3, e);
    if (void 0 !== u) {
      u.push(r);
    } else {
      n3[e] = [r];
    }
    return n3;
  }));
}
__name(_groupBy, "_groupBy");
function groupBy() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _groupBy(t2, n2[0]);
    }, "fn");
  }
  return _groupBy(arguments[0], arguments[1]);
}
__name(groupBy, "groupBy");
function flat(n2) {
  return reduceU(n2, [], (function(n3, t2) {
    if (Array.isArray(t2)) {
      forEachU(t2, (function(t3) {
        n3.push(t3);
      }));
    } else {
      n3.push(t2);
    }
    return n3;
  }));
}
__name(flat, "flat");
function _flatten(n2, t2) {
  var r = 0;
  while (r < n2.length) {
    var e = n2[r];
    if (Array.isArray(e)) {
      flatten(e, t2);
    } else {
      t2.push(e);
    }
    r = r + 1 | 0;
  }
  return t2;
}
__name(_flatten, "_flatten");
function flatten() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _flatten(t2, n2[0]);
    }, "fn");
  }
  return _flatten(arguments[0], arguments[1]);
}
__name(flatten, "flatten");
function deepFlat(n2) {
  return flatten(n2, []);
}
__name(deepFlat, "deepFlat");
function toTuple(n2) {
  return n2;
}
__name(toTuple, "toTuple");
function _tap(n2, t2) {
  forEachU(n2, t2);
  return n2;
}
__name(_tap, "_tap");
function tap() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _tap(t2, n2[0]);
    }, "fn");
  }
  return _tap(arguments[0], arguments[1]);
}
__name(tap, "tap");
function flip(n2) {
  return [n2[1], n2[0]];
}
__name(flip, "flip");
var gn = keepMapU;
function filterMap() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return gn(t2, n2[0]);
    }, "fn");
  }
  return gn(arguments[0], arguments[1]);
}
__name(filterMap, "filterMap");
var _n = keepMapU;
function keepMap() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _n(t2, n2[0]);
    }, "fn");
  }
  return _n(arguments[0], arguments[1]);
}
__name(keepMap, "keepMap");
function _removeFirstBy(n2, t2, r) {
  return reduceU(n2, [false, []], (function(n3, e) {
    var u = n3[1];
    if (n3[0]) {
      u.push(e);
      return [true, u];
    } else if (r(e, t2)) {
      return [true, u];
    } else {
      u.push(e);
      return [false, u];
    }
  }))[1];
}
__name(_removeFirstBy, "_removeFirstBy");
function removeFirstBy() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _removeFirstBy(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _removeFirstBy(arguments[0], arguments[1], arguments[2]);
}
__name(removeFirstBy, "removeFirstBy");
function _removeFirst(n2, t2) {
  return removeFirstBy(n2, t2, equal);
}
__name(_removeFirst, "_removeFirst");
function removeFirst() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _removeFirst(t2, n2[0]);
    }, "fn");
  }
  return _removeFirst(arguments[0], arguments[1]);
}
__name(removeFirst, "removeFirst");
function zipWithIndex(n2) {
  return reduceWithIndexU(n2, [], (function(n3, t2, r) {
    n3.push([t2, r]);
    return n3;
  }));
}
__name(zipWithIndex, "zipWithIndex");
function _all(n2, t2) {
  return everyU(n2, t2);
}
__name(_all, "_all");
function all() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _all(t2, n2[0]);
    }, "fn");
  }
  return _all(arguments[0], arguments[1]);
}
__name(all, "all");
function _any(n2, t2) {
  return someU(n2, t2);
}
__name(_any, "_any");
function any() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _any(t2, n2[0]);
    }, "fn");
  }
  return _any(arguments[0], arguments[1]);
}
__name(any, "any");
function _difference(n2, t2) {
  return reject(uniqBy(n2, (function(n3) {
    return n3;
  })), (function(n3) {
    return includes(t2, n3);
  }));
}
__name(_difference, "_difference");
function difference() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _difference(t2, n2[0]);
    }, "fn");
  }
  return _difference(arguments[0], arguments[1]);
}
__name(difference, "difference");
function _union(n2, t2) {
  return uniqBy(concat(n2, t2), (function(n3) {
    return n3;
  }));
}
__name(_union, "_union");
function union() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _union(t2, n2[0]);
    }, "fn");
  }
  return _union(arguments[0], arguments[1]);
}
__name(union, "union");
function _intersection(n2, t2) {
  var r = n2.length > t2.length ? [n2, t2] : [t2, n2];
  var e = r[1];
  return uniqBy(filter(r[0], (function(n3) {
    return includes(e, n3);
  })), (function(n3) {
    return n3;
  }));
}
__name(_intersection, "_intersection");
function intersection() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _intersection(t2, n2[0]);
    }, "fn");
  }
  return _intersection(arguments[0], arguments[1]);
}
__name(intersection, "intersection");
function sample(n2) {
  return n2[random_int(0, n2.length - 1 | 0)];
}
__name(sample, "sample");
function _flatMap(n2, t2) {
  return flat(mapU(n2, t2));
}
__name(_flatMap, "_flatMap");
function flatMap2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _flatMap(t2, n2[0]);
    }, "fn");
  }
  return _flatMap(arguments[0], arguments[1]);
}
__name(flatMap2, "flatMap");

// ../../node_modules/@mobily/ts-belt/dist/index-69bc96f0.mjs
var Ra = {
  __proto__: null,
  placeholder,
  makeEmpty,
  makeWithIndex,
  make: make2,
  repeat,
  length,
  isEmpty,
  isNotEmpty,
  reverse: $,
  append,
  prepend,
  prependToAll,
  intersperse,
  get: get2,
  at,
  getUnsafe,
  getUndefined,
  getBy,
  find,
  head,
  last,
  tail,
  tailOrEmpty,
  init,
  initOrEmpty,
  take,
  takeExactly,
  takeWhile,
  drop,
  dropExactly,
  dropWhile,
  uncons,
  map,
  mapWithIndex,
  filter,
  keep: P,
  filterWithIndex,
  keepWithIndex: H,
  reject,
  rejectWithIndex,
  reduce,
  reduceReverse,
  reduceWithIndex,
  splitAt,
  splitEvery,
  shuffle: Q,
  partition,
  concat: concat2,
  concatMany: Y,
  every,
  some: some2,
  slice: slice2,
  sliceToEnd: sliceToEnd2,
  eq,
  range: range2,
  rangeBy: rangeBy2,
  copy,
  zip: zip2,
  zipWith,
  unzip: sn,
  replaceAt,
  insertAt,
  updateAt,
  swapAt,
  removeAt,
  uniqBy,
  uniq,
  forEach,
  forEachWithIndex,
  getIndexBy,
  includes,
  join,
  sort,
  sortBy,
  groupBy,
  flat,
  flatten,
  deepFlat,
  toTuple,
  tap,
  flip,
  filterMap,
  keepMap,
  removeFirstBy,
  removeFirst,
  zipWithIndex,
  all,
  any,
  difference,
  union,
  intersection,
  sample,
  flatMap: flatMap2
};

// ../../node_modules/@mobily/ts-belt/dist/Promise.bs-06a7bae6.mjs
var t = create("Promise.JsError");
function $$catch(r, s) {
  return r.catch((function(r2) {
    return _1(s, is_extension(r2) ? r2 : {
      RE_EXN_ID: t,
      _1: r2
    });
  }));
}
__name($$catch, "$$catch");

// ../../node_modules/@mobily/ts-belt/dist/index-e7228f55.mjs
function _is(i3, n2) {
  return typeof i3 === n2;
}
__name(_is, "_is");
function is() {
  if (1 === arguments.length) {
    const i3 = arguments;
    return /* @__PURE__ */ __name(function fn(n2) {
      return _is(n2, i3[0]);
    }, "fn");
  }
  return _is(arguments[0], arguments[1]);
}
__name(is, "is");
function isString(i3) {
  return "string" == typeof i3;
}
__name(isString, "isString");
function isNumber(i3) {
  if ("number" == typeof i3) {
    return !Number.isNaN(i3);
  } else {
    return false;
  }
}
__name(isNumber, "isNumber");
function isBoolean(i3) {
  return "boolean" == typeof i3;
}
__name(isBoolean, "isBoolean");
var isPromise = /* @__PURE__ */ __name((i3) => i3 instanceof Promise, "isPromise");
function isArray(i3) {
  return Array.isArray(i3);
}
__name(isArray, "isArray");
function isObject(i3) {
  if (i3 && !Array.isArray(i3)) {
    return "object" == typeof i3;
  } else {
    return false;
  }
}
__name(isObject, "isObject");
function isFunction(i3) {
  return "function" == typeof i3;
}
__name(isFunction, "isFunction");
var isError = /* @__PURE__ */ __name((i3) => i3 instanceof Error, "isError");
var isDate = /* @__PURE__ */ __name((i3) => i3 instanceof Date, "isDate");
function isNullable(i3) {
  return null == i3;
}
__name(isNullable, "isNullable");
function isNotNullable(i3) {
  return !(null == i3);
}
__name(isNotNullable, "isNotNullable");
var isNull = /* @__PURE__ */ __name((i3) => null === i3, "isNull");
var isUndefined = /* @__PURE__ */ __name((i3) => void 0 === i3, "isUndefined");
function _isNot(i3, n2) {
  return !n2(i3);
}
__name(_isNot, "_isNot");
function isNot() {
  if (1 === arguments.length) {
    const i3 = arguments;
    return /* @__PURE__ */ __name(function fn(n2) {
      return _isNot(n2, i3[0]);
    }, "fn");
  }
  return _isNot(arguments[0], arguments[1]);
}
__name(isNot, "isNot");
var i = {
  __proto__: null,
  is,
  isString,
  isNumber,
  isBoolean,
  isPromise,
  isArray,
  isObject,
  isFunction,
  isError,
  isDate,
  isNullable,
  isNotNullable,
  isNull,
  isUndefined,
  isNot
};

// ../../node_modules/@mobily/ts-belt/dist/index-c1cc4c86.mjs
function placeholder2(n2) {
}
__name(placeholder2, "placeholder");
function makeSome(n2) {
  return some(n2);
}
__name(makeSome, "makeSome");
function makeNone(n2) {
}
__name(makeNone, "makeNone");
function fromNullable(n2) {
  if (null == n2) {
    return;
  } else {
    return some(n2);
  }
}
__name(fromNullable, "fromNullable");
function fromFalsy(n2) {
  if (n2) {
    return n2;
  }
}
__name(fromFalsy, "fromFalsy");
function _fromPredicate(n2, t2) {
  return flatMap(null == n2 ? void 0 : some(n2), (function(n3) {
    if (t2(n3)) {
      return some(n3);
    }
  }));
}
__name(_fromPredicate, "_fromPredicate");
function fromPredicate() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _fromPredicate(t2, n2[0]);
    }, "fn");
  }
  return _fromPredicate(arguments[0], arguments[1]);
}
__name(fromPredicate, "fromPredicate");
function fromExecution(n2) {
  try {
    return some(n2(void 0));
  } catch (n3) {
    return;
  }
}
__name(fromExecution, "fromExecution");
function fromPromise(t2) {
  return $$catch(t2.then((function(n2) {
    return some(n2);
  })), (function(n2) {
    return Promise.resolve(void 0);
  }));
}
__name(fromPromise, "fromPromise");
var h = mapU2;
function map2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return h(t2, n2[0]);
    }, "fn");
  }
  return h(arguments[0], arguments[1]);
}
__name(map2, "map");
var _ = flatMapU;
function flatMap3() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _(t2, n2[0]);
    }, "fn");
  }
  return _(arguments[0], arguments[1]);
}
__name(flatMap3, "flatMap");
var v = mapWithDefaultU;
function mapWithDefault() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return v(t2, n2[0], n2[1]);
    }, "fn");
  }
  return v(arguments[0], arguments[1], arguments[2]);
}
__name(mapWithDefault, "mapWithDefault");
function _mapNullable(n2, t2) {
  if (void 0 !== n2) {
    return nullable_to_opt(t2(valFromOption(n2)));
  }
}
__name(_mapNullable, "_mapNullable");
function mapNullable() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _mapNullable(t2, n2[0]);
    }, "fn");
  }
  return _mapNullable(arguments[0], arguments[1]);
}
__name(mapNullable, "mapNullable");
function _filter2(n2, t2) {
  return flatMapU(n2, (function(n3) {
    if (t2(n3)) {
      return some(n3);
    }
  }));
}
__name(_filter2, "_filter");
function filter2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _filter2(t2, n2[0]);
    }, "fn");
  }
  return _filter2(arguments[0], arguments[1]);
}
__name(filter2, "filter");
var g = getWithDefault;
function getWithDefault2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return g(t2, n2[0]);
    }, "fn");
  }
  return g(arguments[0], arguments[1]);
}
__name(getWithDefault2, "getWithDefault");
var N2 = getExn2;
function toNullable(n2) {
  return getWithDefault(n2, null);
}
__name(toNullable, "toNullable");
function toUndefined(n2) {
  return getWithDefault(n2, void 0);
}
__name(toUndefined, "toUndefined");
function _toResult(n2, t2) {
  if (void 0 !== n2) {
    return {
      TAG: 0,
      _0: valFromOption(n2)
    };
  } else {
    return {
      TAG: 1,
      _0: t2
    };
  }
}
__name(_toResult, "_toResult");
function toResult() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _toResult(t2, n2[0]);
    }, "fn");
  }
  return _toResult(arguments[0], arguments[1]);
}
__name(toResult, "toResult");
function _match(n2, t2, r) {
  if (void 0 !== n2) {
    return t2(valFromOption(n2));
  } else {
    return r(void 0);
  }
}
__name(_match, "_match");
function match() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _match(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _match(arguments[0], arguments[1], arguments[2]);
}
__name(match, "match");
var b = isNone;
var z2 = isSome;
function _tap2(n2, t2) {
  if (void 0 !== n2) {
    t2(valFromOption(n2));
    return n2;
  } else {
    return n2;
  }
}
__name(_tap2, "_tap");
function tap2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _tap2(t2, n2[0]);
    }, "fn");
  }
  return _tap2(arguments[0], arguments[1]);
}
__name(tap2, "tap");
function _contains(n2, r) {
  return mapWithDefaultU(n2, false, (function(n3) {
    return equal(n3, r);
  }));
}
__name(_contains, "_contains");
function contains() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _contains(t2, n2[0]);
    }, "fn");
  }
  return _contains(arguments[0], arguments[1]);
}
__name(contains, "contains");
function _zip(n2, t2) {
  if (void 0 !== n2 && void 0 !== t2) {
    return [valFromOption(n2), valFromOption(t2)];
  }
}
__name(_zip, "_zip");
function zip3() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _zip(t2, n2[0]);
    }, "fn");
  }
  return _zip(arguments[0], arguments[1]);
}
__name(zip3, "zip");
function _zipWith(n2, t2, r) {
  if (void 0 !== n2 && void 0 !== t2) {
    return some(r(valFromOption(n2), valFromOption(t2)));
  }
}
__name(_zipWith, "_zipWith");
function zipWith2() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _zipWith(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _zipWith(arguments[0], arguments[1], arguments[2]);
}
__name(zipWith2, "zipWith");
function _fold(n2, t2, r) {
  if (void 0 !== n2) {
    return t2(valFromOption(n2));
  } else {
    return r(void 0);
  }
}
__name(_fold, "_fold");
function fold() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _fold(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _fold(arguments[0], arguments[1], arguments[2]);
}
__name(fold, "fold");
function all2(n2) {
  return reduceU(n2, [], (function(n3, t2) {
    return flatMapU(n3, (function(n4) {
      if (void 0 !== t2) {
        return concat(n4, [valFromOption(t2)]);
      }
    }));
  }));
}
__name(all2, "all");
var Some = /* @__PURE__ */ __name((n2) => n2, "Some");
var P2 = {
  __proto__: null,
  Some,
  None: void 0,
  placeholder: placeholder2,
  makeSome,
  makeNone,
  fromNullable,
  fromFalsy,
  fromPredicate,
  fromExecution,
  fromPromise,
  map: map2,
  flatMap: flatMap3,
  mapWithDefault,
  mapNullable,
  filter: filter2,
  getWithDefault: getWithDefault2,
  getExn: N2,
  toNullable,
  toUndefined,
  toResult,
  match,
  isNone: b,
  isSome: z2,
  tap: tap2,
  contains,
  zip: zip3,
  zipWith: zipWith2,
  fold,
  all: all2
};

// ../../node_modules/@mobily/ts-belt/dist/index-f9f94373.mjs
function placeholder3(n2) {
}
__name(placeholder3, "placeholder");
function make3(n2) {
  return String(n2);
}
__name(make3, "make");
function length2(n2) {
  return n2.length;
}
__name(length2, "length");
function _concat(n2, t2) {
  return n2.concat(t2);
}
__name(_concat, "_concat");
function concat3() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _concat(t2, n2[0]);
    }, "fn");
  }
  return _concat(arguments[0], arguments[1]);
}
__name(concat3, "concat");
function _append2(n2, t2) {
  return n2.concat(t2);
}
__name(_append2, "_append");
function append2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _append2(t2, n2[0]);
    }, "fn");
  }
  return _append2(arguments[0], arguments[1]);
}
__name(append2, "append");
function _prepend2(n2, t2) {
  return t2.concat(n2);
}
__name(_prepend2, "_prepend");
function prepend2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _prepend2(t2, n2[0]);
    }, "fn");
  }
  return _prepend2(arguments[0], arguments[1]);
}
__name(prepend2, "prepend");
function _slice(n2, t2, e) {
  return n2.slice(t2, e);
}
__name(_slice, "_slice");
function slice3() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _slice(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _slice(arguments[0], arguments[1], arguments[2]);
}
__name(slice3, "slice");
function _sliceToEnd(n2, t2) {
  return n2.slice(t2);
}
__name(_sliceToEnd, "_sliceToEnd");
function sliceToEnd3() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _sliceToEnd(t2, n2[0]);
    }, "fn");
  }
  return _sliceToEnd(arguments[0], arguments[1]);
}
__name(sliceToEnd3, "sliceToEnd");
function toLowerCase(n2) {
  return n2.toLowerCase();
}
__name(toLowerCase, "toLowerCase");
function toUpperCase(n2) {
  return n2.toUpperCase();
}
__name(toUpperCase, "toUpperCase");
function trim(n2) {
  return n2.trim();
}
__name(trim, "trim");
function trimStart(n2) {
  return n2.trimStart();
}
__name(trimStart, "trimStart");
function trimEnd(n2) {
  return n2.trimEnd();
}
__name(trimEnd, "trimEnd");
function isEmpty2(n2) {
  return 0 === n2.length;
}
__name(isEmpty2, "isEmpty");
function isNotEmpty2(n2) {
  return n2.length > 0;
}
__name(isNotEmpty2, "isNotEmpty");
function _split(n2, t2) {
  return n2.split(t2);
}
__name(_split, "_split");
function split() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _split(t2, n2[0]);
    }, "fn");
  }
  return _split(arguments[0], arguments[1]);
}
__name(split, "split");
function _splitByRe(n2, t2) {
  return n2.split(t2);
}
__name(_splitByRe, "_splitByRe");
function splitByRe() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _splitByRe(t2, n2[0]);
    }, "fn");
  }
  return _splitByRe(arguments[0], arguments[1]);
}
__name(splitByRe, "splitByRe");
function _splitAt2(n2, t2) {
  return [n2.slice(0, t2), n2.slice(t2)];
}
__name(_splitAt2, "_splitAt");
function splitAt2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _splitAt2(t2, n2[0]);
    }, "fn");
  }
  return _splitAt2(arguments[0], arguments[1]);
}
__name(splitAt2, "splitAt");
function _includes2(n2, t2) {
  return n2.includes(t2);
}
__name(_includes2, "_includes");
function includes2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _includes2(t2, n2[0]);
    }, "fn");
  }
  return _includes2(arguments[0], arguments[1]);
}
__name(includes2, "includes");
function _replace(n2, t2, e) {
  return n2.replace(t2, e);
}
__name(_replace, "_replace");
function replace() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _replace(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _replace(arguments[0], arguments[1], arguments[2]);
}
__name(replace, "replace");
function _replaceAll(n2, e, r) {
  var i3 = n2.split(e);
  return reduceWithIndexU(i3, "", (function(n3, t2, e2) {
    var c = e2 < (i3.length - 1 | 0) ? t2.concat(r) : t2;
    return n3.concat(c);
  }));
}
__name(_replaceAll, "_replaceAll");
function replaceAll() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _replaceAll(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _replaceAll(arguments[0], arguments[1], arguments[2]);
}
__name(replaceAll, "replaceAll");
function _replaceByRe(n2, t2, e) {
  return n2.replace(t2, e);
}
__name(_replaceByRe, "_replaceByRe");
function replaceByRe() {
  if (2 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _replaceByRe(t2, n2[0], n2[1]);
    }, "fn");
  }
  return _replaceByRe(arguments[0], arguments[1], arguments[2]);
}
__name(replaceByRe, "replaceByRe");
function _remove(n2, t2) {
  return n2.replace(t2, "");
}
__name(_remove, "_remove");
function remove() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _remove(t2, n2[0]);
    }, "fn");
  }
  return _remove(arguments[0], arguments[1]);
}
__name(remove, "remove");
function _removeAll(n2, t2) {
  return replaceAll(n2, t2, "");
}
__name(_removeAll, "_removeAll");
function removeAll() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _removeAll(t2, n2[0]);
    }, "fn");
  }
  return _removeAll(arguments[0], arguments[1]);
}
__name(removeAll, "removeAll");
function _search(n2, t2) {
  var e = n2.search(t2);
  if (e < 0) {
    return;
  } else {
    return e;
  }
}
__name(_search, "_search");
function search() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _search(t2, n2[0]);
    }, "fn");
  }
  return _search(arguments[0], arguments[1]);
}
__name(search, "search");
function _match2(n2, t2) {
  return null_to_opt(n2.match(t2));
}
__name(_match2, "_match");
function match2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _match2(t2, n2[0]);
    }, "fn");
  }
  return _match2(arguments[0], arguments[1]);
}
__name(match2, "match");
function _repeat(n2, t2) {
  return n2.repeat(t2);
}
__name(_repeat, "_repeat");
function repeat2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _repeat(t2, n2[0]);
    }, "fn");
  }
  return _repeat(arguments[0], arguments[1]);
}
__name(repeat2, "repeat");
function _indexOf(n2, t2) {
  var e = n2.indexOf(t2);
  if (e < 0) {
    return;
  } else {
    return e;
  }
}
__name(_indexOf, "_indexOf");
function indexOf() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _indexOf(t2, n2[0]);
    }, "fn");
  }
  return _indexOf(arguments[0], arguments[1]);
}
__name(indexOf, "indexOf");
function _lastIndexOf(n2, t2) {
  var e = n2.lastIndexOf(t2);
  if (e < 0) {
    return;
  } else {
    return e;
  }
}
__name(_lastIndexOf, "_lastIndexOf");
function lastIndexOf() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _lastIndexOf(t2, n2[0]);
    }, "fn");
  }
  return _lastIndexOf(arguments[0], arguments[1]);
}
__name(lastIndexOf, "lastIndexOf");
function _endsWith(n2, t2) {
  return n2.endsWith(t2);
}
__name(_endsWith, "_endsWith");
function endsWith() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _endsWith(t2, n2[0]);
    }, "fn");
  }
  return _endsWith(arguments[0], arguments[1]);
}
__name(endsWith, "endsWith");
function _startsWith(n2, t2) {
  return n2.startsWith(t2);
}
__name(_startsWith, "_startsWith");
function startsWith() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _startsWith(t2, n2[0]);
    }, "fn");
  }
  return _startsWith(arguments[0], arguments[1]);
}
__name(startsWith, "startsWith");
function _getUnsafe2(n2, t2) {
  return n2[t2];
}
__name(_getUnsafe2, "_getUnsafe");
function getUnsafe2() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _getUnsafe2(t2, n2[0]);
    }, "fn");
  }
  return _getUnsafe2(arguments[0], arguments[1]);
}
__name(getUnsafe2, "getUnsafe");
function _get(n2, t2) {
  return undefined_to_opt(n2[t2]);
}
__name(_get, "_get");
function get3() {
  if (1 === arguments.length) {
    const n2 = arguments;
    return /* @__PURE__ */ __name(function fn(t2) {
      return _get(t2, n2[0]);
    }, "fn");
  }
  return _get(arguments[0], arguments[1]);
}
__name(get3, "get");
function toArray(t2) {
  return makeByU(t2.length, (function(n2) {
    return t2[n2];
  }));
}
__name(toArray, "toArray");
function head2(n2) {
  return undefined_to_opt(n2[0]);
}
__name(head2, "head");
function last2(n2) {
  return undefined_to_opt(n2[n2.length - 1 | 0]);
}
__name(last2, "last");
var i2 = {
  __proto__: null,
  placeholder: placeholder3,
  make: make3,
  length: length2,
  concat: concat3,
  append: append2,
  prepend: prepend2,
  slice: slice3,
  sliceToEnd: sliceToEnd3,
  toLowerCase,
  toUpperCase,
  trim,
  trimStart,
  trimEnd,
  isEmpty: isEmpty2,
  isNotEmpty: isNotEmpty2,
  split,
  splitByRe,
  splitAt: splitAt2,
  includes: includes2,
  replace,
  replaceAll,
  replaceByRe,
  remove,
  removeAll,
  search,
  match: match2,
  repeat: repeat2,
  indexOf,
  lastIndexOf,
  endsWith,
  startsWith,
  getUnsafe: getUnsafe2,
  get: get3,
  toArray,
  head: head2,
  last: last2
};

// src/getInitials/getInitials.ts
var getInitials = /* @__PURE__ */ __name((displayName) => pipe(P2.fromNullable(displayName), P2.map((v2) => pipe(i2.split(v2, " "), Ra.map((word) => {
  const codePoint = capitalizeEachWord(word).codePointAt(0);
  return i.isNumber(codePoint) ? String.fromCodePoint(codePoint) : "";
}), Ra.filter(i2.isNotEmpty), (arr) => Ra.filterWithIndex(arr, (index) => index === 0 || index === arr.length - 1), Ra.join(""))), P2.getWithDefault("")), "getInitials");

// src/parseUserIdFromToken/parseUserIdFromToken.ts
var parseUserIdFromToken = /* @__PURE__ */ __name((token) => {
  const [, payload] = token.split(".");
  if (!payload) throw new Error("Token is missing");
  return JSON.parse(atob(payload))?.user_id;
}, "parseUserIdFromToken");

// src/stringify/stringify.ts
import { configure, stringify as stableStringify } from "safe-stable-stringify";
var stringify = configure({
  deterministic: false
});
var stringifyDeterministic = stableStringify;

// src/validateIBAN/validateIBAN.ts
var validateIBAN = /* @__PURE__ */ __name((iban) => {
  const cleanIban = iban.replace(/\s+/g, "").toUpperCase();
  if (!/^PL\d{26}$/.test(cleanIban)) return false;
  const rearranged = cleanIban.slice(4) + cleanIban.slice(0, 4);
  let remainder = 0;
  for (let i3 = 0; i3 < rearranged.length; i3++) {
    const ch = rearranged[i3];
    if (ch && ch >= "0" && ch <= "9") {
      remainder = (remainder * 10 + (ch.charCodeAt(0) - 48)) % 97;
    } else if (ch) {
      const mapped = (ch.charCodeAt(0) - 55).toString();
      for (let j = 0; j < mapped.length; j++) {
        remainder = (remainder * 10 + (mapped.charCodeAt(j) - 48)) % 97;
      }
    }
  }
  return remainder === 1;
}, "validateIBAN");
export {
  capitalizeEachWord,
  deleteCookie,
  formatDurationToHoursAndMinutes,
  getCookie,
  getInitials,
  parseUserIdFromToken,
  setCookie,
  setSessionCookie,
  stringify,
  stringifyDeterministic,
  validateIBAN
};
